import { useFormik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import SearchIcon from "../../icons/SearchIcon";
import { httpReauest } from "../../utils/httpRequest";
import Loading from "../../components/common/Loading";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";
import ArrowLeftIcon from "../../icons/ArrowLeftIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import { FilterContext } from "../../context/FilterContext";
import FilterMobile from "../../components/common/FilterMobile";
import { ProductContext } from "../../context/ProductContext";
import { useRouteInfo } from "../../hooks/useRouteInfo";
import { Helmet } from "react-helmet";

const CategoryPage = () => {
  const [category, setcategory] = useState([]);
  const [vehicle, setvehicle] = useState([]);
  const [products, setProducts] = useState([]);
  const [brands, setbrands] = useState([]);
  const [uniquebrands, setuniquebrands] = useState([]);
  const [querys, setquerys] = useState([]);
  const [show, setshow] = useState();
  const [showFilter, setshowFilter] = useState();
  const [havFilter, sethavFilter] = useState(false);
  const [hasmore, sethasmore] = useState(false);
  const [loading, setloading] = useState(false);
  const [selectedBrand, setselectedBrand] = useState(false);
  const [findedBrand, setfindedBrand] = useState(false);
  const [selectedCategory, setselectedCategory] = useState(false);
  const [producLoading, setproducLoading] = useState(false);
  const { metaData } = useRouteInfo();
  const filterData = useContext(FilterContext);
  const { setselectProduct } = useContext(ProductContext);

  const {
    filter_category,
    filter_year_start,
    filter_year_end,
    filter_min_price,
    filter_max_price,
    filter_haveImg,
    filter_onFire,
    filter_search_key,
    filter_brand,
    filter_lazing,
    sort,
    setsort,
  } = filterData;

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setloading(true);
    const pastQuerys = JSON.parse(localStorage.getItem("query"));
    if (pastQuerys) {
      setquerys(pastQuerys);
    }
    await httpReauest("GET", "/category/header", {}, {}).then(({ data }) => {
      setcategory(data?.data?.categories);
      setvehicle(data?.data?.urls);
      setuniquebrands(data?.data?.brands);
    });

    await httpReauest("GET", "/brand", {}, {}).then(({ data }) => {
      setbrands(data?.data);
    });
    setloading(false);
  }

  const formik = useFormik({
    initialValues: {
      category: "",
      name: "",
      brand: "",
      search_key: "",
      search_type: "",
      year_start: 1340,
      year_end: 1403,
      min_price: 0,
      max_price: 20,
      min_tonaj: 0,
      max_tonaj: 10,
      onFire: false,
      haveImg: false,
    },
  });

  async function handleData() {
    setproducLoading(true);
    const page = 1;
    await httpReauest(
      "GET",
      `/vehicle?page=${page}&category=${formik.values.category}&search_key=${formik.values.name}&brand=${formik.values.brand}&sort=${sort}&search_type=${formik.values.search_type}`,
      {},
      {}
    ).then(({ data }) => {
      setProducts(data.data);
      if (data?.data?.length == 16) {
        sethasmore(true);
      } else {
        sethasmore(false);
      }
    });
    setproducLoading(false);
  }

  useEffect(() => {
    handleData();
  }, [formik.values.category, formik.values.name, formik.values.brand, sort]);

  async function handleSubmit(e, value) {
    if (formik.values.search_key == "" && !value) {
      return;
    }
    e?.preventDefault();

    const pastQuerys = JSON.parse(localStorage.getItem("query"));

    if (pastQuerys) {
      const arr = [];
      pastQuerys?.map((e) => arr.push(e));
      const repeate = pastQuerys.find(
        (query) => query == (value ? value : formik.values.search_key)
      );
      if (!repeate) {
        arr.push(value ? value : formik.values.search_key);
      }
      localStorage.setItem("query", JSON.stringify(arr));
    } else {
      const arr = [];
      arr.push(value ? value : formik.values.search_key);
      localStorage.setItem("query", JSON.stringify(arr));
    }

    setproducLoading(true);
    await httpReauest(
      "GET",
      `/vehicle?search_key=${
        value ? value : formik.values.search_key
      }&search_type=${formik.values.search_type}`,
      {},
      {}
    ).then(({ data }) => {
      setProducts(data.data);

      if (data?.data?.length == 16) {
        sethasmore(true);
      } else {
        sethasmore(false);
      }
    });
    setproducLoading(false);
  }

  async function fetchData(event) {
    const page = event === "filter" ? 1 : products.length / 16 + 1;
    if (event === "filter") {
      setproducLoading(true);
    }
    await httpReauest(
      "GET",
      "/vehicle?page=" +
        page +
        "&category=" +
        formik.values.category +
        "&year_start=" +
        formik.values.year_start +
        "&year_end=" +
        formik.values.year_end +
        "&min_price=" +
        formik.values.min_price +
        "&max_price=" +
        formik.values.max_price +
        "&min_tonaj=" +
        formik.values.min_tonaj +
        "&max_tonaj=" +
        formik.values.max_tonaj +
        "&name=" +
        formik.values.name +
        "&haveImg=" +
        formik.values.haveImg +
        "&onFire=" +
        formik.values.onFire +
        "&brand=" +
        formik.values.brand +
        "&lazing=" +
        filter_lazing +
        "&sort=" +
        sort,
      {},
      {}
    ).then(({ data }) => {
      if (event === "filter") {
        setProducts(data.data);
      } else {
        setProducts((cur) => [...cur, ...data.data]);
      }

      if (data?.data?.length == 16) {
        sethasmore(true);
      } else {
        sethasmore(false);
      }
    });
    if (event === "filter") {
      setproducLoading(false);
    }
  }

  useEffect(() => {
    const fetchBrand = async () => {
      if (selectedBrand && brands) {
        const foundItem = brands.find((item) => item.name === selectedBrand);
        if (foundItem) {
          setfindedBrand(foundItem);
        }
      }
    };
    fetchBrand();
  }, [selectedBrand, brands]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>
      <FilterMobile
        showFilter={showFilter}
        formik={formik}
        setshowFilter={setshowFilter}
        fetchData={fetchData}
        sethavFilter={sethavFilter}
      />

      {loading ? (
        <Loading />
      ) : (
        <div className="text-[14px] sm:text-[16px]">
          <span className="relative w-full ">
            <form onSubmit={handleSubmit} className="z-40">
              <input
                onFocus={() => {
                  setshow(true);
                }}
                onBlur={() => {
                  setTimeout(() => setshow(false), 200);
                }}
                className="w-full form-brand px_se xl:min-w-[210px] h-[58px]"
                placeholder="جستجو در همه آگهی ها"
                id="search_key"
                name="search_key"
                onChange={formik.handleChange}
                value={formik.values.search_key}
              />
              {show && (
                <span className="absolute bg-white w-full left-0 top-full z-40  rounded-[8px] border">
                  {querys
                    ?.reverse()
                    ?.slice(0, 6)
                    ?.map((e) => (
                      <button
                        onClick={(s) => {
                          formik.setFieldValue("search_key", e);
                          handleSubmit(s, e);
                          setshow(false);
                        }}
                        type="button"
                        className="flex justify-between px-3 py-3 w-full items-center"
                      >
                        <span>{e}</span>
                        <span>
                          <ArrowLeftIcon />
                        </span>
                      </button>
                    ))}
                </span>
              )}
            </form>
            <span className="absolute translate-y-[-50%] top-[50%] left-4">
              <img
                onClick={() => setshowFilter(true)}
                src="/Filter.png"
                alt="filter"
              />
            </span>

            <span className="absolute translate-y-[-50%] top-[50%] right-4">
              <SearchIcon />
            </span>
          </span>
          <div className="w-full flex gap-2 py-4 mt-2 overflow-x-scroll border-b border-dashed border-[#8E9192]">
            {category?.map((cat) => (
              <span
                onClick={() => {
                  if (cat._id === formik.values.category) {
                    formik.setFieldValue("category", "");
                    setselectedCategory("");
                  } else {
                    formik.setFieldValue("category", cat._id);
                    formik.setFieldValue("brand", "");
                    formik.setFieldValue("name", "");
                    setselectedCategory(cat);
                    setselectedBrand("");
                  }
                }}
                className={`${
                  formik.values.category === cat._id
                    ? "bg-black text-white"
                    : ""
                } border-brand-2 px-3 py-2 whitespace-nowrap font-bold  flex flex-col justify-between items-center`}
              >
                <img
                  src={CDN_BASE_URL + cat.img}
                  alt={cat.name}
                  className="w-12 h-10 object-contain"
                />
                {cat.name}
              </span>
            ))}
          </div>
          <div className="w-full flex gap-2 py-4 overflow-x-scroll border-b border-dashed border-[#8E9192]">
            {selectedCategory
              ? uniquebrands?.map((e) => {
                  if (e.category === selectedCategory._id) {
                    return (
                      <span
                        onClick={() => {
                          if (e?.brand._id === formik.values.brand) {
                            formik.setFieldValue("brand", "");
                            setselectedBrand("");
                            formik.setFieldValue("name", "");
                          } else {
                            formik.setFieldValue("brand", e.brand?._id);
                            setselectedBrand(e.brand.name);
                            formik.setFieldValue("name", "");
                          }
                        }}
                        className={`${
                          formik.values.brand === e.brand?._id
                            ? "bg-black text-white"
                            : ""
                        } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
                      >
                        {e.brand.title}
                      </span>
                    );
                  }
                })
              : brands.map((e) => {
                  return (
                    <span
                      onClick={() => {
                        if (e._id === formik.values.brand) {
                          formik.setFieldValue("brand", "");
                          setselectedBrand("");
                          formik.setFieldValue("name", "");
                        } else {
                          formik.setFieldValue("brand", e._id);
                          setselectedBrand(e.name);
                          formik.setFieldValue("name", "");
                        }
                      }}
                      className={`${
                        formik.values.brand === e._id
                          ? "bg-black text-white"
                          : ""
                      } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
                    >
                      {e.title}
                    </span>
                  );
                })}
          </div>
          {selectedBrand ? (
            <div className="w-full flex gap-2 py-4 overflow-x-scroll border-b border-dashed border-[#8E9192] ">
              <>
                <span
                  onClick={() => formik.setFieldValue("name", "")}
                  className={`${
                    formik.values.name == "" ? "bg-black text-white" : ""
                  } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
                >
                  همه
                </span>
                {vehicle?.map((e) => {
                  if (selectedBrand) {
                    if (e.brand.name === selectedBrand) {
                      return (
                        <span
                          onClick={() =>
                            e.name === formik.values.name
                              ? formik.setFieldValue("name", "")
                              : formik.setFieldValue("name", e.name)
                          }
                          className={`${
                            formik.values.name === e.name
                              ? "bg-black text-white"
                              : ""
                          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
                        >
                          {e.menu}
                        </span>
                      );
                    }
                  } else {
                    return (
                      <span
                        onClick={() =>
                          e.name === formik.values.name
                            ? formik.setFieldValue("name", "")
                            : formik.setFieldValue("name", e.name)
                        }
                        className={`${
                          formik.values.name === e.name
                            ? "bg-black text-white"
                            : ""
                        } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
                      >
                        {e.name}
                      </span>
                    );
                  }
                })}
              </>
            </div>
          ) : null}
          <span className="relative ms-auto  mt-4 block">
            <select
              id="lazing"
              name="lazing"
              onChange={(e) => setsort(e.target.value)}
              className={` form-brand h-[35px] w-full`}
            >
              <option value={"-createdAt"}> جدید ترین</option>
              <option value={"createdAt"}> قدیمی ترین</option>
              <option value={"price"}> ارزان ترین</option>
              <option value={"-price"}> گران ترین</option>
              <option value={"-year"}> سال ساخت از بیشترین</option>
              <option value={"year"}> سال ساخت از کمترین</option>
            </select>
            <p className="on-border">مرتب سازی</p>
          </span>
          <InfiniteScroll
            dataLength={products?.length ? products?.length : 16} //This is important field to render the next data
            next={fetchData}
            hasMore={hasmore}
            loader={"Loading..."}
          >
            {producLoading ? (
              <Loading />
            ) : (
              <>
                <div className="grid grid-cols-3 gap-1 py-3">
                  {products?.map((e) => (
                    <Link
                      onClick={() => setselectProduct(e?._id)}
                      to={`/${e?.url?.category?.url}/${e?.url?.brand?.name}/${e?.url?.name}/${e?.vehicle_number}`}
                    >
                      {e?.img?.img_webp ? (
                        <picture>
                          <source
                            type="image/webp"
                            srcset={CDN_BASE_URL + e?.img?.img_webp}
                          />
                          <img
                            src={CDN_BASE_URL + e?.img?.img_jpg}
                            alt={e?.name}
                            className="object-cover rounded-[6px] h-[29vw] w-full"
                            loading="lazy"
                          />
                        </picture>
                      ) : e?.img ? (
                        <img
                          src={CDN_BASE_URL + e?.img}
                          alt={e?.name}
                          className="object-cover rounded-[6px] h-[29vw] w-full"
                          loading="lazy"
                        />
                      ) : (
                        <img
                          loading="lazy"
                          src={"/no-image.jpg"}
                          alt={e?.name}
                          className="object-cover rounded-[6px] h-[29vw] w-full"
                        />
                      )}
                    </Link>
                  ))}
                </div>
              </>
            )}
          </InfiniteScroll>
          {!hasmore && findedBrand && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  selectedCategory?.url === "light-truck"
                    ? findedBrand.desc_lighttruck
                    : selectedCategory?.url === "truck"
                    ? findedBrand.desc_truck
                    : selectedCategory?.url === "heavy-truck"
                    ? findedBrand.desc_heavytruck
                    : selectedCategory?.url === "truck-accessories-equipment"
                    ? findedBrand.desc_accessories
                    : findedBrand.desc,
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default CategoryPage;
